module.exports = __webpack_public_path__ + "img/advising.f817bfe0.jpg";